import React from 'react'
import { LineBreak } from 'shop/components/Shop/commonStyles'
import {
  CartErrorMessage,
  CartProductError,
  OrderItemWithVatPrices,
  OrderItem,
  OrderItemWithLimit
} from 'shop/types/cart'
import ProductInfoItem from '../ProductInfoItem'

export const renderProductItems = (
  items: (OrderItemWithVatPrices | OrderItem | OrderItemWithLimit)[],
  error: CartProductError
) => {
  const showPrice = error.message === CartErrorMessage.PRODUCT_PRICES_CHANGED
  const showLimit = error.message === CartErrorMessage.PRODUCT_LIMIT_REACHED

  return items.map((item, index) => {
    const isLast = items.length === index + 1
    return (
      <React.Fragment key={`${item.id}-${index}`}>
        <ProductInfoItem
          item={item}
          showPrice={showPrice}
          showLimit={showLimit}
        />
        {!isLast && <LineBreak />}
      </React.Fragment>
    )
  })
}

const getProductErrorContent = (
  hasMultipleItems: boolean,
  storeName: string
) => ({
  [CartErrorMessage.PRODUCT_PRICES_CHANGED]: {
    header: `${hasMultipleItems ? 'Some prices have changed' : 'Price change'}`,
    body: `The following product${hasMultipleItems ? 's have' : ' has'} changed. To accept these changes, click continue.`
  },
  [CartErrorMessage.PRODUCTS_OUT_OF_STOCK]: {
    header: `${hasMultipleItems ? 'Some products are out of stock' : 'Product out of stock'}`,
    body: `Unfortunately, the following product${hasMultipleItems ? 's are' : ' is'} out of stock in the ${storeName} store. Continuing will remove ${hasMultipleItems ? 'them' : 'it'} from your basket.`
  },
  [CartErrorMessage.INVALID_MODIFIERS]: {
    header: `Unavailable Modifiers`,
    body: `Unfortunately, the following product${hasMultipleItems ? 's have' : ' has'} unavailable modifier${hasMultipleItems ? 's' : '(s)'}. Continuing will remove ${hasMultipleItems ? 'them' : 'the product'} from your basket.`
  },
  [CartErrorMessage.PRODUCTS_UNAVAILABLE]: {
    header: `${hasMultipleItems ? 'Unavailable products' : `Unavailable product`}`,
    body: `Unfortunately, the following product${hasMultipleItems ? 's are' : ' is'} no longer available in the ${storeName} store. Continuing will remove ${hasMultipleItems ? 'them' : 'it'} from your basket.`
  },
  [CartErrorMessage.PRODUCT_LIMIT_REACHED]: {
    header: 'Product limit reached',
    body: `You can only have a limited number of the following product${hasMultipleItems ? 's' : ''}. If items have exceeded their limits, continuing will remove those items from your basket.`
  }
})

export const getErrorCopy = (
  error: CartProductError,
  hasMultipleItems: boolean,
  storeName: string
) => {
  return getProductErrorContent(hasMultipleItems, storeName)[error.message]
}
